import {
  showLoading,
  toggle,
  getSiblings,
  isMobDevice,
  addRemove,
} from "./helpers";

import { sliderStreams, sliderVods } from "./Sliders";

/* variable
**************************************************************/
let btnGames = [
  ...document.querySelectorAll(`#filter_games_extra .game:not(.more)`),
];
let btnGamesMore = document.querySelector("#filter_games_extra .game.more");
let btnMore = document.querySelector(`.read-more__button.streams`);
let optLang = document.querySelector(`[name='sort_lang']`);
let optView = document.querySelector(`[name='sort_view']`);
let optSortBy = document.querySelector(`[name='sort_by']`);
let page = document.querySelector(`#content`).getAttribute("data-page");
let searchBox = document.querySelector(`.filter-sort__drop-box.search`);
let searchInput = document.querySelector(`.filter-sort__search`);
let isAjaxCalled = false;
let gameFilters = [];

if (page === "streams") {
  for (let i = 0; i < btnGames.length; i++) {
    let id = btnGames[i].getAttribute("data-twitch-id");
    if (id && !gameFilters.includes(id)) {
      gameFilters.push(id);
    }
  }
}

/* Get twitch streams
**************************************************************/
function getTwitchStreams(
  event,
  gameFilters,
  lang,
  views,
  sortBy,
  offset,
  searchString
) {
  let container = document.querySelector(`#streams`);
  let action = searchString !== "" ? "search_vods" : "get_twitch_streams";

  $.ajax({
    type: "POST",
    url: themeVars.adminUrl,
    data: {
      action: action,
      query: searchString,
      metaQuery: {
        game: gameFilters,
        language: lang,
      },
      queryVars: {
        page: page,
        sortBy: sortBy,
        views: views,
        offset: event === "loadmore" ? offset : 0,
      },
    },
    beforeSend: function() {
      btnMore !== null ? (btnMore.style.display = "none") : "";
      nothingFound("true");
      showLoading(document, true);

      if (event !== "loadmore") {
        container.querySelectorAll(`.video-card`).forEach(item => {
          item.remove();
        });
      }
    },
    success: function(result) {
      isAjaxCalled = false;
      showLoading(document, false);
      container.insertAdjacentHTML("beforeend", result);
      openPopupWindow();
      btnMore !== null && result !== ""
        ? (btnMore.style.display = "block")
        : "";
      nothingFound();

      if (event === "loadmore") {
        container.setAttribute("data-offset", Number(offset) + 20);
      } else {
        container.setAttribute("data-offset", 27);
      }
    },
    error: function(error) {
      console.error(error);
      isAjaxCalled = false;
    },
  });
}

/*
**************************************************************/
function nothingFound(flag) {
  let noResult = document.querySelector(".no-result");

  if (flag === "true") {
    noResult.style.display = "none";
  } else {
    let cards = document.querySelectorAll(`.video-card`);
    if (cards.length > 0) {
      noResult.style.display = "none";
    } else {
      noResult.style.display = "block";
    }
  }
}

/* Stream GameBar Navigation show/hide view more games
**************************************************************/
if (btnGamesMore !== null) {
  btnGamesMore.addEventListener("click", function() {
    toggle(this.firstElementChild);
    toggle(this.lastElementChild);
    document.querySelector(`.filter-sort__container`).classList.toggle("extra");

    for (const i in btnGames) {
      if (btnGames[i].classList.contains("hidden")) {
        btnGames[i].classList.toggle("hide");
      }
    }
  });
}

/* Stream GameBar Filter show/hide all games
**************************************************************/
let tabFilter = document.querySelector(`.filter-sort__btn`);
if (tabFilter !== null) {
  document
    .querySelector(`.filter-sort__btn`)
    .addEventListener("click", function(event) {
      let element = event.target;
      let filterGames = document.querySelector(`#filter_games_extra`);

      if (element.classList.contains("active")) {
        element.classList.remove("active");
        filterGames.classList.remove("active");
        if (searchBox !== null) {
          searchBox.classList.remove("mobile-search");
          searchBox.classList.add("desktop");
        }
      } else {
        element.classList.add("active");
        getSiblings(element).forEach(el => el.classList.remove("active"));
        if (searchBox !== null) {
          searchBox.classList.remove("mobile-search");
          searchBox.classList.add("desktop");
        }

        if (element.getAttribute("data-type") === "filter") {
          filterGames.classList.add("active");
        } else if (element.getAttribute("data-type") === "all") {
          let lang = optLang.options[optLang.selectedIndex].value;
          let views =
            optView !== null
              ? optView.options[optView.selectedIndex].value
              : "";

          getTwitchStreams("load", gameFilters, lang, views);
          filterGames.classList.remove("active");
          filterGames.querySelector(`.game.active`) !== null
            ? filterGames
                .querySelector(`.game.active`)
                .classList.remove("active")
            : "";
        } else if (element.getAttribute("data-type") === "search") {
          filterGames.classList.remove("active");
          if (searchBox.classList.contains("mobile-search")) {
            searchBox.classList.remove("mobile-search");
            searchBox.classList.add("desktop");
          } else {
            searchBox.classList.remove("desktop");
            searchBox.classList.add("mobile-search");
          }
        }
      }
    });
}

/* load streams by click game button
**************************************************************/
for (let i = 0; i < btnGames.length; i++) {
  btnGames[i].addEventListener("click", function() {
    let id = btnGames[i].getAttribute("data-twitch-id");
    let lang =
      optLang !== null ? optLang.options[optLang.selectedIndex].value : "";
    let views =
      optView !== null ? optView.options[optView.selectedIndex].value : "";
    let sortBy =
      optSortBy !== null
        ? optSortBy.options[optSortBy.selectedIndex].value
        : "";
    let offset = 0;

    if (page === "streams") {
      btnGames[i].classList.add("active");
      getSiblings(btnGames[i]).forEach(el => el.classList.remove("active"));
      getTwitchStreams("load", id, lang, views, sortBy, offset, "");
    } else {
      if (btnGames[i].classList.contains("active")) {
        btnGames[i].classList.remove("active");
      } else {
        btnGames[i].classList.add("active");
      }
      let event = searchInput.value !== "" ? "search" : "load";

      addRemove(gameFilters, id);
      getTwitchStreams(
        event,
        gameFilters,
        lang,
        views,
        sortBy,
        offset,
        searchInput.value
      );
    }
  });
}

/* load more vods by click button "See more"
**************************************************************/
if (btnMore !== null) {
  btnMore.addEventListener("click", function() {
    let container = document.querySelector(`#streams`);
    let offset = container.getAttribute("data-offset");

    let lang =
      optLang !== null ? optLang.options[optLang.selectedIndex].value : "";
    let views =
      optView !== null ? optView.options[optView.selectedIndex].value : "";
    let sortBy =
      optSortBy !== null
        ? optSortBy.options[optSortBy.selectedIndex].value
        : "";
    let searchString =
      searchInput !== null && searchInput.value !== "" ? searchInput.value : "";

    getTwitchStreams(
      "loadmore",
      gameFilters,
      lang,
      views,
      sortBy,
      offset,
      searchString
    );
  });
}

/* Language changed
**************************************************************/
if (optLang !== null) {
  optLang.addEventListener("change", function() {
    optionChanges();
  });
}

/* Viewers sort changed
**************************************************************/
if (optView !== null) {
  optView.addEventListener("change", function() {
    optionChanges();
  });
}

/* VOD's sort by
**************************************************************/
if (optSortBy !== null) {
  optSortBy.addEventListener("change", function() {
    optionChanges();
  });
}

/* Function for option
**************************************************************/
function optionChanges() {
  let lang =
    optLang !== null ? optLang.options[optLang.selectedIndex].value : "";
  let views =
    optView !== null ? optView.options[optView.selectedIndex].value : "";
  let sortBy =
    optSortBy !== null ? optSortBy.options[optSortBy.selectedIndex].value : "";
  let event =
    searchInput !== null && searchInput.value !== "" ? "search" : "load";
  let searchString =
    searchInput !== null && searchInput.value !== "" ? searchInput.value : "";

  if (page === "streams") {
    let activeGame = document.querySelector(`#filter_games_extra .game.active`);
    gameFilters =
      activeGame !== null
        ? activeGame.getAttribute("data-twitch-id")
        : gameFilters;
  }

  getTwitchStreams(event, gameFilters, lang, views, sortBy, 0, searchString);
}

/* Change positions of elements in the featured-streams__box
**************************************************************/
let topStreams = document.querySelectorAll(`.featured-streams__stream`);
for (let i = 0; i < topStreams.length; i++) {
  topStreams[i].addEventListener("click", function() {
    let container = document.querySelector(`.featured-streams__main-video`);
    let mainTitle = document.querySelector(`.featured-streams__main-title`);
    let mainGame = document.querySelector(
      `.featured-streams__main-extra-item.game`
    );
    let mainLang = document.querySelector(
      `.featured-streams__main-extra-item.lang`
    );
    let mainViews = document.querySelector(
      `.featured-streams__main-extra-item.views`
    );
    let mainDescr = document.querySelector(`.featured-streams__main-text`);

    let prevStore = {
      title: mainTitle.innerHTML,
      game: mainGame.innerHTML,
      views: mainViews.innerHTML,
      lang: mainLang.innerHTML,
      channel: container.getAttribute("data-channel"),
      image: container.style.backgroundImage,
      description: mainDescr.innerHTML,
    };

    let newStore = {
      title: this.getAttribute("data-title"),
      game: this.getAttribute("data-game"),
      views: this.getAttribute("data-views"),
      lang: this.getAttribute("data-lang"),
      channel: this.getAttribute("data-channel"),
      image: this.style.backgroundImage,
      description: this.getAttribute("data-description"),
    };

    // set new data for main block
    mainTitle.innerHTML = newStore.title;
    mainGame.innerHTML = newStore.game;
    mainViews.innerHTML = newStore.views;
    mainLang.innerHTML = newStore.lang;
    container.setAttribute("data-channel", newStore.channel);
    container.style.backgroundImage = newStore.image.replace(
      "140x84",
      "510x280"
    );
    mainDescr.innerHTML = newStore.description;

    // set new data for prev block
    this.setAttribute("data-title", prevStore.title);
    this.setAttribute("data-game", prevStore.game);
    this.setAttribute("data-lang", prevStore.lang);
    this.setAttribute("data-views", prevStore.views);
    this.setAttribute("data-channel", prevStore.channel);
    this.style.backgroundImage = prevStore.image.replace("510x280", "140x84");
    this.setAttribute("data-description", prevStore.description);

    deleteTwitchPlayer();
  });
}

/* Run stream click by button "Watch Stream"
**************************************************************/
let btnWatch = document.querySelector(".featured-streams__main-button");
if (btnWatch !== null) {
  btnWatch.addEventListener("click", function(event) {
    event.preventDefault();
    let container = document.querySelector(`.featured-streams__main-video`);
    let channel = container.getAttribute("data-channel");
    let type = container.getAttribute("data-type");
    runTwitchPlayer(container, channel, type);
  });
}

/* Open popup
**************************************************************/
function openPopupWindow() {
  let videoIcon = document.querySelectorAll(".video-card__img");
  for (let i = 0; i < videoIcon.length; i++) {
    videoIcon[i].addEventListener("click", function() {
      let channel = this.getAttribute("data-channel");
      let type = this.getAttribute("data-type");
      let popup = document.querySelector(`.stream-popup`);
      let container = popup.querySelector(`.stream-window`);
      popup.classList.add("show");

      runTwitchPlayer(container, channel, type);
    });
  }
}

/* Ajax load streams, vods
**************************************************************/
function loadVideosAjax(main) {
  let container = main.querySelector(".swiper-wrapper");
  let action =
    container.getAttribute("data-type") === "streams"
      ? "load_streams"
      : "load_vods";
  let page = document.querySelector("#content").getAttribute("data-page");
  let game = container.getAttribute("data-game");
  let string = container.getAttribute("data-string");

  $.ajax({
    type: "POST",
    url: themeVars.adminUrl,
    data: {
      action: action,
      queryVars: {
        page: page,
        game: game,
        string: string,
      },
    },
    beforeSend: function() {},
    success: function(result) {
      result.trim() !== "" ? (main.style.display = "block") : "";
      container.insertAdjacentHTML("beforeend", result);
      openPopupWindow();

      action === "load_streams" ? sliderStreams.update() : sliderVods.update();
    },
    error: function(error) {
      console.error(error);
    },
  });
}

/* first load
**************************************************************/
document.addEventListener("DOMContentLoaded", function() {
  openPopupWindow();
  changeClassFilterBox();

  setTimeout(function() {
    window.addEventListener("scroll", function() {
      let container = document.querySelectorAll(`.preview-cards`);

      if (window.scrollY > 500 && !isAjaxCalled) {
        for (let i = 0; i < container.length; i++) {
          isAjaxCalled = true;

          loadVideosAjax(container[i]);
        }
      }
    });
  }, 5000);
});

/* Close popup window with Twitch player
**************************************************************/
let btnClosePopup = document.querySelector(`.stream-close`);
if (btnClosePopup !== null) {
  btnClosePopup.addEventListener("click", function() {
    let popup = this.parentElement.parentElement;
    popup.classList.remove("show");
    deleteTwitchPlayer();
  });
}

/* Delete previous Twitch player
**************************************************************/
function deleteTwitchPlayer() {
  let oldPlayer = document.querySelector(`#player`);
  oldPlayer !== null ? oldPlayer.remove() : "";
}

/* Run new Twitch player
**************************************************************/
function runTwitchPlayer(container, channel, type) {
  deleteTwitchPlayer();

  let element = document.createElement("div");
  element.id = "player";
  container.appendChild(element);
  let options = {};

  if (type === "streams") {
    options = {
      channel: channel,
      autoplay: true,
    };
  } else if (type === "vods") {
    options = {
      video: channel,
      autoplay: true,
    };
  }

  /*eslint-disable-next-line*/
  let player = new Twitch.Player("player", options);
}

/* VOD's search functionall
**************************************************************/
if (searchInput !== null) {
  searchInput.addEventListener("keyup", e => {
    const searchString = e.target.value;
    let lang =
      optLang !== null ? optLang.options[optLang.selectedIndex].value : "";
    let views =
      optView !== null ? optView.options[optView.selectedIndex].value : "";
    let sortBy =
      optSortBy !== null
        ? optSortBy.options[optSortBy.selectedIndex].value
        : "";
    let offset = 20;

    if (searchString.length >= 2 && !isAjaxCalled) {
      isAjaxCalled = true;
      getTwitchStreams(
        "search",
        gameFilters,
        lang,
        views,
        sortBy,
        offset,
        searchString
      );
    } else if (searchString.length === 0) {
      getTwitchStreams("load", gameFilters, lang, views, sortBy);
    }
  });
}

/* VOD's with parameters to sort the request
**************************************************************/
let link = document.querySelectorAll(`.switches__item.switches__item_right a`);
for (let i = 0; i < link.length; i++) {
  if (link[i] !== null && link[i].innerHTML !== "See all news") {
    link[i].addEventListener("click", function(e) {
      let href = e.target.getAttribute("href");
      let blockTitle = "";

      if (page === "tournament") {
        blockTitle = document.querySelector(`.tournament-block__title`);
      } else if (page === "team") {
        blockTitle = document.querySelector(`.core-banner__info-team-name`);
      } else if (page === "player") {
        blockTitle = document.querySelector(`.player__current-name`);
      } else if (page === "game") {
        blockTitle = document.querySelector(".match-container-ongoing");
      }

      if (href) {
        let value = page !== "game" ? blockTitle.innerHTML : "";
        let game = blockTitle.getAttribute("data-game");

        value = encodeURIComponent(value);
        game = encodeURIComponent(game);
        location.href = href + `?filter=${value}&game=${game}`;
        e.preventDefault();
      }
    });
  }
}

if (page === "vods" || page === "streams") {
  let urlString = location.href;
  let url = new URL(urlString);
  let filter = url.searchParams.get("filter");
  let game_id = url.searchParams.get("game");

  if (game_id !== null) {
    let game = document.querySelector(
      `#filter_games_extra .game[data-api-id='${game_id}']`
    );
    let twitch_id = game.getAttribute("data-twitch-id");
    game.classList.add("active");
    searchInput.value = filter;

    addRemove(gameFilters, twitch_id);
    getTwitchStreams("search", gameFilters, "", "", "published_at", 20, filter);
  }
}

/* Running on Mobile
**************************************************************/
function changeClassFilterBox() {
  let filterBox = document.querySelectorAll(`.filter-sort__drop-box`);
  for (let i = 0; i < filterBox.length; i++) {
    if (isMobDevice()) {
      filterBox[i].classList.remove("desktop");
      filterBox[i].classList.add("mobile");
    } else {
      filterBox[i].classList.add("desktop");
      filterBox[i].classList.remove("mobile");
    }
  }
}

/* On Resize
**************************************************************/
window.addEventListener("resize", function() {
  changeClassFilterBox();
});

/* Streams AJAX Load
**************************************************************/
if (page === "streams") {
  document.addEventListener("DOMContentLoaded", function() {
    getTwitchStreams("load", "", "", "", "published_at", "", "");
  });
}



// WEBPACK FOOTER //
// ./scripts/modules/Ajax-twitch-streams.js